
// 浏览器缓存 indexDB

import { isNN } from "../utils/tools";

//最大约250M
//当前版本菜单存储
//login页面存储（背景图片使用base64存储）

//几个问题：
//1、一个库下可以建立多个表，但目前的操作类不能实现一个库下建立多个表。因为后面的表未触发onupgradeneeded
//  因此，一个库维持一个表 menus-menustable-keys,values
//2、没有api获取所有的库名，因此库名不能动态，比如以uid/unid建立库（除非有规律）
//  因此，库名最好是确定的：menus,dics，区分多人时，将人放到key中，获取key后，根据uid过滤




/**
 * dbName 数据库名
 * storeName 表名--
 * indexList 索引列表
 */


/* 打开数据库 */
export function openDB(dbName, storeName, version = 1, primaryKey='id', indexList = []) {
  return new Promise((resolve, reject) => {
      let {indexedDB} = window
      let con:any;
      const request = indexedDB.open(dbName, version);
      request.onsuccess = function (event) {
          con = event.target.result;
          resolve(con)
      }
      request.onerror = function (event) {
          reject(event)
      }
      // 数据库创建或升级的时候会触发
      request.onupgradeneeded = (e) => {
          con = e.target.result;
          if (!con.objectStoreNames.contains(storeName)) {
              let objectStore = con.createObjectStore(storeName, { keyPath: primaryKey , unique: true})//设置主键
              //添加自定义索引
              if (indexList.length) {
                  indexList.forEach(item => {
                      objectStore.createIndex(item, item, { unique: false })//索引值可能会重复，所以设为false
                  })
              }
          }
      }
  })
}

/* 新增数据 */
export function addData(db, storeName, data) {
  return new Promise((resolve, reject) => {
      const request = db.transaction([storeName], 'readwrite')// 事务对象 指定表格名称和操作模式（"只读"或"读写"）
          .objectStore(storeName)
          .add(data)

      request.onsuccess = (e) => {
          resolve(e)
      }
      request.onerror = (e) => {
          throw new Error(e.target.error)
      }
  })
}

/* 新增数据--只读 */
export function addDataReadOnly(db, storeName, data) {
    return new Promise((resolve, reject) => {
        const request = db.transaction([storeName], 'readonly')
            .objectStore(storeName)
            .add(data)

        request.onsuccess = (e) => {
            resolve(e)
        }
        request.onerror = (e) => {
            throw new Error(e.target.error)
        }
    })
  }

/**
* 通过主键读取数据
*/
export function getDataByKey(db, storeName, key) {
  return new Promise((resolve, reject) => {
      const request = db.transaction([storeName])
          .objectStore(storeName)
          .get(key)
      request.onsuccess = (e) => {
          resolve(request.result)
      }
      request.onerror = (e) => {
          throw new Error(e.target.error)
      }
  })
}

/* 通过游标读取所有数据 */
export function cursorGetData(db, storeName) {
  let list = []
  const request = db.transaction([storeName], 'readwrite')
      .objectStore(storeName)
      .openCursor()
  return new Promise((resolve, reject) => {
      request.onsuccess = (e) => {
          let cursor = e.target.result
          if (cursor) {
              list.push(cursor.value)
              cursor.continue() //遍历存储对象中所有内容
          } else {
              resolve(list)
          }
      }
      request.onerror = (e) => {
          reject(e)
      }
  })
}

/* 通过游标读取所有Keys */
export function cursorGetKeys(db, storeName, primaryKey:string) {
    let list = []
    const request = db.transaction([storeName], 'readwrite')
        .objectStore(storeName)
        .openCursor()
    return new Promise((resolve, reject) => {
        request.onsuccess = (e) => {
            let cursor = e.target.result
            if (cursor) {
                //获取key
                list.push(cursor.value[primaryKey])
                cursor.continue();
            } else {
                resolve(list)
            }
        }
        request.onerror = (e) => {
            reject(e)
        }
    })
}

/* 通过游标读取所有指定开头的Keys */
export function cursorGetKeysStartWith(db, storeName, primaryKey:string, keyValue:string) {
    let list = []
    const request = db.transaction([storeName], 'readwrite')
        .objectStore(storeName)
        .openCursor()
    return new Promise((resolve, reject) => {
        request.onsuccess = (e) => {
            let cursor = e.target.result
            if (cursor) {
                //获取key
                if(cursor.value[primaryKey].startsWith(keyValue)){
                    //替换掉
                    list.push(`${cursor.value[primaryKey]}`.replace(keyValue,''));
                }
                cursor.continue();
            } else {
                resolve(list)
            }
        }
        request.onerror = (e) => {
            reject(e)
        }
    })
}

/* 通过索引读取数据 */
export function getDataByIndex(db, storeName, indexName, indexValue) {
  const request = db.transaction([storeName], 'readwrite')
      .objectStore(storeName)
      .index(indexName)
      .get(indexValue)

  return new Promise((resolve, reject) => {
      request.onerror = function (e) {
          reject(e)
      }
      request.onsuccess = function (e) {
          resolve(e.target.result)
      }
  })
}
/**
* 通过索引和游标查询记录
*/
export function cursorGetDataByIndex(db, storeName, indexName, indexValue) {
  let list = []
  const request = db.transaction(storeName, 'readwrite').objectStore(storeName) // 仓库对象
      .index(indexName) // 索引对象
      .openCursor(IDBKeyRange.only(indexValue)) // 指针对象
  return new Promise((resolve, reject) => {
      request.onsuccess = function (e) {
          let cursor = e.target.result
          if (cursor) {
              list.push(cursor.value)
              cursor.continue() // 遍历了存储对象中的所有内容
          } else {
              resolve(list)
          }
      }
      request.onerror = function (ev) {
          reject(ev)
      }
  })
}

/* 更新数据 -- 没有则添加 */
export function updateDB(db, storeName, data) {
  const request = db.transaction([storeName], 'readwrite')
      .objectStore(storeName)
      .put(data)
  return new Promise((resolve, reject) => {
      request.onsuccess = (ev) => {
          resolve(ev)
      }
      request.onerror = (ev) => {
          reject(ev)
      }
  })
}

/* 通过主键 删除数据 */
export function deleteDBByKey(db, storeName, primaryKey) {
  const request = db.transaction([storeName], 'readwrite')
      .objectStore(storeName)
      .delete(primaryKey)
  return new Promise((resolve, reject) => {
      request.onsuccess = (ev) => {
          resolve(ev)
      }
      request.onerror = (ev) => {
          reject(ev)
      }
  })
}

/* 通过主键列表 删除数据 */
export function deleteDBByKeys(db, storeName, primaryKeys) {
    const trans = db.transaction([storeName], 'readwrite');
    const store = trans.objectStore(storeName);
    let request:any;
    for(let key in primaryKeys){
        request = store.delete(key);
    }

    //仅取了最后一个的结果
    return new Promise((resolve, reject) => {
        request.onsuccess = (ev) => {
            resolve(ev)
        }
        request.onerror = (ev) => {
            reject(ev)
        }
    })
}

/**
* 删除数据库
*/
// export function delIndexDB(dbName:string) {
//   let request = window.indexedDB.deleteDatabase(dbName)
//   return new Promise((resolve, reject) => {
//     request.onsuccess = (ev) => {
//         resolve("成功")
//     }
//     request.onerror = (ev) => {
//         reject(ev)
//     }
//   })
// }
export function delIndexDB(dbName: string) {
    return new Promise((resolve, reject) => {
        const request = window.indexedDB.deleteDatabase( dbName )
        request.onsuccess = () => {
            resolve(true)
        }
        request.onerror = (ev) => {
            reject(ev)
        }
        request.onblocked = () => {
            console.log('数据库删除被占用')
        }
    })
}



/**
* 关闭数据库
*/
export function closeDB(db) {
  db.close()
}

export default {
  openDB,
  addData,
  getDataByKey,
  cursorGetData,
  getDataByIndex,
  cursorGetDataByIndex,
  updateDB,
  deleteDBByKey,
  delIndexDB,
  closeDB
}


//async表示异步函数（表示不会阻塞后续操作），返回固定的Promis对象
//使用await只能在async内部用。可以暂停执行，直到Promis解决（或决绝）；
//可以将一个异步操作的结果给一个变量，就像同步操作一样
export async function setIndexDbMenu(bucket:string, groupName:string, uNavCtxtVer:string, value:any) {
  //获取数据库连接
  const db = await openDB(bucket, groupName, 1, 'u_nav_ctxt_ver');//IDBDatabase
  //获取对应数据
  const data1 = await getDataByKey(db, groupName, uNavCtxtVer);

  //如果该主键对应的数据已存在，则做更新操作
  value['u_nav_ctxt_ver'] = uNavCtxtVer;//必须把id放到value中，否则加入不了
  let rpt:any;
  if(data1){
    rpt = await updateDB(db, groupName, value);
  }else{
    rpt = await addData(db, groupName, value);
  }
  closeDB(db);
  return rpt;
}

// 设置数据
export async function setIndexDbDic(bucket:string, groupName:string, ver:any, dic:any) {
    if(isNN(dic)){
        //先全部删除
        await delIndexDB(bucket);

        //获取数据库连接
        const db = await openDB(bucket, groupName, 1, 'dic_name');//IDBDatabase

        //把版本信息存入
        await addData(db, groupName, {v:ver,'dic_name':'ver'});
        //字典信息存入
        for(let dicItemName in dic){
            //新增div_name 必须把id放到value中，否则加入不了
            addData(db, groupName, {'v':dic[dicItemName], 'dic_name':dicItemName});//for中不能加await
        }
        //closeDB(db);
    }
}

// 获取数据：返回数据中没有u_nav
export async function getIndexDbMenuKeys(bucket:string, groupName:string, uidNav:string) {
    const db = await openDB(bucket, groupName, 1, 'u_nav_ctxt_ver')
    let keys = await cursorGetKeysStartWith(db, groupName, 'u_nav_ctxt_ver', uidNav);
    closeDB(db);
    return keys;
}


// 删除指定key的数据
export async function rmvIndexDbMenuKeys(bucket:string, groupName:string, keys:string[]) {
    const db = await openDB(bucket, groupName, 1, 'u_nav_ctxt_ver')
    await deleteDBByKeys(db, groupName, keys);
    closeDB(db);
}

// 根据key获取获取数据
export async function getIndexDbMenuVal(bucket:string, groupName:string, uNavCtxtVerKey:string) {
  const db = await openDB(bucket, groupName, 1, 'u_nav_ctxt_ver');
  const data1 = await getDataByKey(db, groupName, uNavCtxtVerKey);
  closeDB(db);
  return data1;
}


// 根据key获取获取数据
export async function getIndexDbDicService(bucket:string, groupName:string, dicName:string) {
  const db = await openDB(bucket, groupName, 1, 'dic_name');
  const data1 = await getDataByKey(db, groupName, dicName);
  closeDB(db);
  //v才是真实数据
  return data1?data1['v']:undefined;
}

export async function getDataBySubkey(bucket:string, groupName:string, dicName:string, subkey:Array<string>) {
    const db = await openDB(bucket, groupName, 1, 'dic_name');
    const data1 = await getDataByKey(db, groupName, dicName);
    let result = data1;
    for(let i=0;i<subkey.length;i++){
        result = result[subkey[i]];
    }
    console.log("getDataBySubkey@@@", result);

    return result;
}